import moment from 'moment'

export const curDate = (value) =>{
  const status =  moment(value).isAfter(moment(new Date()).format('YYYY-MM-DD'))
    if(status) return false
     return true
}